export const PLAN_ACTION = {
    NEW: 'new',
    VIEW: 'view',
    EDIT: 'edit',
    AMEND: 'amend',
    REPLACE: 'replace',
    LODGE_ADDITIONALS: 'lodge_additionals'
};

export const TAB_DESCRIPTION = {
    IN_DESIGN: 'In design',
    READY_FOR_QA: 'Ready for QA',
    READY_FOR_CERTIFICATION: 'Ready for certification',
    CERTIFIED: 'Ready for lodgement',
    LODGED: 'Lodged'
};

export const PDF_CREATION_METHOD = {SURVEYOR_PORTAL: 'SURVEYOR_PORTAL', CAD_SOFTWARE: 'CAD_SOFTWARE', DIGITAL_PLAN: 'DIGITAL_PLAN'};

export const DATE_FORMAT = 'dd/MM/yyyy HH:mm:ss';

export const DATE_ONLY_FORMAT = 'dd/MM/yyyy';

export const PLAN_VALIDATION_STAGE = {
    LODGEMENT_INFORMATION: 'LODGEMENT_INFORMATION',
    LODGEMENT_ANALYSIS: 'LODGEMENT_ANALYSIS',
    LODGEMENT_INTERESTS: 'LODGEMENT_INTERESTS',
    LODGEMENT_DESIGN: 'LODGEMENT_DESIGN',
    LODGEMENT_CERTIFICATION: 'LODGEMENT_CERTIFICATION',
    LODGEMENT_LODGE: 'LODGEMENT_LODGE',
    LODGEMENT_ADDITIONALS: 'LODGEMENT_ADDITIONALS'
};

export const RULE_OUTCOME = {
    PASS: 'PASS',
    INFO: 'INFO',
    WARNING: 'WARNING',
    ERROR: 'ERROR',
    CRITICAL: 'CRITICAL'
};

export const VALIDATION_EVENT_TYPE = {
    INFORMATION: 'INFORMATION',
    SPATIAL: 'SPATIAL',
    LODGE: 'LODGE',
    LODGEMENT: 'LODGEMENT',
    LODGE_ADDITIONALS: 'LODGE_ADDITIONALS',
    ANALYSIS: 'ANALYSIS',
    CERTIFICATION: 'CERTIFICATION',
    REQUEST_QA_CERTIFICATION: 'REQUEST_QA_CERTIFICATION'
};

export const VALIDATION_RESULT_TYPE = {PASS: 1, ERROR: 2, WARNING: 3, INFO: 4, SYSTEM_ERROR: 5};

export const VALIDATION_STATUS = {INPROGRESS: 'INPROGRESS', ERROR: 'ERROR', TIMEOUT: 'TIMEOUT', SUCCESS: 'SUCCESS', COMPLETE: 'COMPLETE'};

export const TABS = {
    INFORMATION: 'Plan Information',
    LODGE: 'Lodge Plan Information',
    DESIGN: 'Design',
    DIGITAL_PLAN: 'Digital Plan',
    ANALYSIS: 'Analysis',
    DASHBOARD: 'My dashboard',
    CERTIFICATION: 'Certification',
    INTERESTS: 'Interests',
    ADDITIONALS: 'Additionals'
};

export const DASHBOARD_TAB = {
    IN_DESIGN: 'IN_DESIGN',
    READY_FOR_QA: 'READY_FOR_QA',
    READY_FOR_CERTIFICATION: 'READY_FOR_CERTIFICATION',
    CERTIFIED: 'CERTIFIED',
    LODGED: 'LODGED'
};

export const PLAN_LODGEMENT_STAGE = {
    IN_DESIGN: 'IN_DESIGN',
    READY_FOR_QA: 'READY_FOR_QA',
    READY_FOR_CERTIFICATION: 'READY_FOR_CERTIFICATION',
    CERTIFIED: 'CERTIFIED',
    LODGED: 'LODGED'
};

export const PLAN_LODGEMENT_STAGE_DESCRIPTION = {
    IN_DESIGN: 'In design',
    READY_FOR_QA: 'Ready for QA',
    READY_FOR_CERTIFICATION: 'Ready for certification',
    CERTIFIED: 'Certified',
    LODGED: 'Lodged'
};

export const PLAN_LODGEMENT_STAGE_ACRONYM = {
    IN_DESIGN: 'DESIGN',
    READY_FOR_QA: 'RQA',
    READY_FOR_CERTIFICATION: 'RFC',
    CERTIFIED: 'CRT',
    LODGED: 'LDGD'
};

export const LODGEMENT_TYPE = {NEW: 'NEW', AMENDMENT: 'AMENDMENT', REPLACEMENT: 'REPLACEMENT'};

export const PDF_CREATION_METHOD_DESCRIPTION = {SURVEYOR_PORTAL: 'Surveyor Portal', CAD_SOFTWARE: 'CAD Software', DIGITAL_PLAN: 'Digital Plan'};

export const ATTACHMENT_PLAN_PDF = 'PLAN_PDF';
export const ATTACHMENT_CSD = 'CADASTRAL_SURV';
export const LAND_CSV = 'LAND_CSV';
export const NON_LOT_COMMON_PROPERTY = 'COMMON PROPERTY';
export const COMMON_PROPERTY = 'CP';

/**
 * Strata, survey-strata, community land and community building plans are all identified under a single SP prefix, so
 * for these parent plan types the code is not the prefix the plan number is shown with. Only the parent plan type
 * lookup carries the undecomposed code - a plan's own type arrives as a plan type lookup, whose smpId is the prefix.
 */
export const SP_PREFIXED_PARENT_PLAN_TYPES = ['CBLD', 'CLND', 'SSP'];

export const PATTERNS = {
    ALPHANUMERIC_PATTERN: /(^[-A-Za-z0-9/() ]+$)/,
    ALPHANUMERIC_AND_LENGTH_PATTERN: /^[-A-Za-z0-9/() ]{0,50}$/,
    DOCUMENT_PATTERN: /(^[A-Z][0-9]{6}[A-C]?$)|(^[A-Z]{0,2}[1-9][0-9]{0,5}[A-C]?\/[0-9]{4}$)/,
    LOT_PATTERN: /(^\d{1,6}$|^\d{1,6}[-]\d{1,6}$)/,
    PARENT_LOT_PATTERN: /^[A-Z]{1,2}|[A-Z]{0,2}\d{1,6}$/,
    PARENT_LOT_RANGE_PATTERN: /^([A-Z]{0,2})?(\d{1,6})$|^([A-Z]{0,2})?(\d{1,6})[-]([A-Z]{0,2})?(\d{1,6})$/,
    SURVEY_PATTERN: /(^(DP|SP|D|P)([1-9][0-9]{0,5})$)/,
    TITLE_PATTERN:
        /^(((LG)?\d{1,4}[-]\d{1,4}A?)|(CL\d{1,5}[-]\d{4})|((EC|ET)\d{1,4}A?)|((GC|GT)\d{1,2}[-]\d{1,4}A?)|(LR\d{1,4}[-]\d{1,4})|(PE\d{1,4}[-]\d{1,4})|(RG\d{1})|(SR\d{1}[-]\d{1,3})|(SP\d{1,5}))$/,
    ANGLE_PATTERN: /^((3[0-5][0-9]|[12][0-9][0-9]|[0]?[1-9][0-9]|[0]{0,2}[0-9])(\:[0-5][0-9])?(\:[0-5][0-9])?)$/,
    SHORT_ANGLE_PATTERN: /^((3[0-5][0-9]|[12][0-9][0-9]|[0]?[1-9][0-9]|[0]{0,2}[0-9])(\.[0-5][0-9])?([0-5][0-9])?)$/,
    PLAN_NUMBER_PATTERN: /^([D][P]|[P]|[D]|[S][P])\d{1,8}/,
    LAND_PATTERN: /^\d{1,9}$/,
    PARCEL_PATTERN: /^(([A-Z]{0,2})([0-9]{0,6})\/(DP|SP|D|P)?([1-9][0-9]{0,5}))$/
};

export const NEW_INTEREST_CREATED_BY = {
    PLAN: {CODE: 'PLAN', DISPLAY: 'This plan', VALUE: 'THIS PLAN'},
    DOCUMENT: {CODE: 'DOCUMENT', DISPLAY: 'Document', VALUE: 'DOCUMENT'},
    DOCUMENT_AND_PLAN: {
        CODE: 'DOCUMENT_AND_PLAN',
        DISPLAY: 'This plan and doc',
        VALUE: 'THIS PLAN & DOCUMENT'
    }
};

export const XMLHTTP_REQUEST_READY_STATE = {UNSENT: 0, OPENED: 1, HEADERS_RECEIVED: 2, LOADING: 3, DONE: 4};

export const HTTP_STATUS_CODES = {
    OK: 200,
    CREATED: 201,
    NO_CONTENT: 204,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    INTERNAL_SERVER_ERROR: 500
};

export const PREVIEW_EXTENSIONS_CONSTRAINT = ['.CSD', '.TXT', '.XYZ', '.PTS', '.PDF', '.CSV', '.DOC', '.DOCX', '.DWG', '.MSG'];

export const NAV_MENUS = {
    HOME: 'HOME',
    DASHBOARD: 'DASHBOARD',
    PLAN_DETAIL: 'PLAN DETAIL'
};

export const IDENTIFY_FEATURES_ORDERING = {
    angleFeatureLayer: 1,
    pointFeatureLayer: 2,
    controlPointFeatureLayer: 2,
    constructPointFeatureLayer: 3,
    lineFeatureLayer: 4,
    constructLineFeatureLayer: 5,
    polygonFeatureLayer: 6,
    annotationFeatureLayer: 7
};

export const HELP_LINK_CONTENTS_BASE_URL = 'assets/help/';
export const HELP_CONTENTS_STYLE = 'assets/help/help.scss';

export const HELP_CONTENT_TYPE = {
    PARENT: 'parentHelpContent',
    SUB_PARENT: 'subParentHelpContent',
    MAIN: 'helpContent'
};

export const NESTED_HELP_ITEMS = ['annotation', 'construction', 'enlargement', 'attribute-editor', 'column-chooser', 'feature-filter'];

export enum NLR_TABS {
    INFORMATION = 0,
    ANALYSIS = 1,
    INTERESTS = 2,
    DESIGN = 3,
	DIGITAL_PLAN = 4,
    CERTIFICATION = 5,
    LODGE = 6,
    ADDITIONALS = 7
}
